import styles from "./DataVisual.module.scss";
import { motion } from "framer-motion";

const mapPercentageToMax = (percentage: number, max: number): number => {
  return (percentage / 100) * max;
};

const Icon = ({
  index,
  delay,
  initialDelay,
  isOn,
  isActive,
}: {
  index: number;
  delay: number;
  initialDelay: number;
  isOn: boolean;
  isActive: boolean;
}) => (
  <svg
    className={styles.svg}
    width="25"
    height="110"
    viewBox="0 0 25 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={index}
  >
    <motion.path
      d="M12.2136 27.8828C5.47358 27.8828 9.82438e-06 33.3532 9.82438e-06 40.0924V109.058H24.4258V40.0924C24.4258 33.3546 18.9536 27.8828 12.2122 27.8828H12.2136Z"
      //   fill="#dca0d2"
      //   initial={{ fillOpacity: 0.35 }}
      //   animate={isOn && isActive ? { fillOpacity: 1 } : {}}
      fill="#B45CA6"
      initial={{ fill: "#dca0d2" }}
      animate={isOn && isActive ? { fill: "#B45CA6" } : {}}
      transition={{ delay: initialDelay + delay }}
    />
    <motion.path
      d="M12.2136 24.4192C5.46825 24.4192 4.00543e-05 18.9528 4.00543e-05 12.2096C4.00543e-05 5.46644 5.46825 0 12.2136 0C18.959 0 24.4272 5.46644 24.4272 12.2096C24.4272 18.9528 18.959 24.4192 12.2136 24.4192Z"
      //   fill="#dca0d2"
      //   initial={{ fillOpacity: 0.35 }}
      //   animate={isOn && isActive ? { fillOpacity: 1 } : {}}
      fill="#B45CA6"
      initial={{ fill: "#dca0d2" }}
      animate={isOn && isActive ? { fill: "#B45CA6" } : {}}
      transition={{ delay: initialDelay + delay }}
    />
  </svg>
);

export default function DataVisual({
  percentage,
  isActive,
}: {
  percentage: number;
  isActive: boolean;
}) {
  const numberOfIcons = 98;
  const mappedValue = mapPercentageToMax(percentage, numberOfIcons);
  const staggerDelay = 0.05; // delay between each element's animation
  const initialDelay = 0.5; // initial delay before starting the staggered animations

  return (
    <div className={styles.dataVisual}>
      {Array.from({ length: numberOfIcons }).map((_, i) => {
        const isOn = i >= numberOfIcons - mappedValue;
        const delay = (numberOfIcons - i - 1) * staggerDelay;
        return (
          <Icon
            key={i}
            index={i}
            delay={delay}
            initialDelay={initialDelay}
            isOn={isOn}
            isActive={isActive}
          />
        );
      })}
    </div>
  );
}
